export default "__VITE_PUBLIC_ASSET__22af23d2__"